var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"row"},_vm._l((_vm.kpis),function(kpi){return _c('div',{staticClass:"col-lg-4"},[_c('highcharts',{attrs:{"options":kpi}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }